import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "max-w-5xl overflow-x-auto" }
const _hoisted_2 = ["onClick"]

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import Stepper from 'primevue/stepper';
import Step from 'primevue/step';
import StepList from 'primevue/steplist';
import Divider from 'primevue/divider';

import { useCurrentSegment } from '@/composables/useCurrentSegment';
import { useNavigationHelpers } from '@/composables/useNavigationHelpers';
import type { ViewGroup } from '@/utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationGroupStepper',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const { navigableSegmentGroups } = useCurrentSegment();
const { getStepperNavigation } = useNavigationHelpers();

const currentGroupIndex = computed(() => {
  return (
    Number(
      navigableSegmentGroups.value?.findIndex((group) => group.id === Number(route.params.groupId))
    ) + 1
  );
});

const handleStepperUpdate = (group: ViewGroup) => {
  const { shouldNavigate, route: navigationRoute } = getStepperNavigation(
    group,
    route.params
  );

  if (shouldNavigate && navigationRoute) {
    router.push(navigationRoute);
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(navigableSegmentGroups).length > 1)
      ? (_openBlock(), _createBlock(_unref(Stepper), {
          key: 0,
          value: currentGroupIndex.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(StepList), null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigableSegmentGroups), (group, index) => {
                  return (_openBlock(), _createBlock(_unref(Step), {
                    key: group.id,
                    value: index + 1,
                    onClick: ($event: any) => (handleStepperUpdate(group)),
                    asChild: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center", {
              'flex-1': index !== _unref(navigableSegmentGroups).length - 1,
            }])
                      }, [
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["flex h-7 w-7 min-w-7 items-center justify-center rounded-full border-2 text-sm", {
                'border-brand-500 bg-brand-500 text-white': index + 1 === currentGroupIndex.value,
                'border-[#e2e8f0] text-[#64748b]': index + 1 !== currentGroupIndex.value,
              }]),
                          onClick: ($event: any) => (handleStepperUpdate(group))
                        }, [
                          _createTextVNode(_toDisplayString(index + 1), 1)
                        ], 10, _hoisted_2)), [
                          [
                            _directive_tooltip,
                            group.name,
                            void 0,
                            { top: true }
                          ]
                        ]),
                        (index !== _unref(navigableSegmentGroups).length - 1)
                          ? (_openBlock(), _createBlock(_unref(Divider), { key: 0 }))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})